import * as React from 'react';
import { colors } from '../../../index';

const IconExchange = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.669 8.253V7.084H4.163v-.876l-1.46 1.46 1.46 1.461v-.876h3.506zm2.629-2.922l-1.46-1.46v.876H5.33v1.169h3.506v.876l1.46-1.46zM12.927 6.5A6.434 6.434 0 006.5.073 6.434 6.434 0 00.073 6.5 6.434 6.434 0 006.5 12.927 6.434 6.434 0 0012.927 6.5zm-11.685 0c0-2.9 2.358-5.258 5.258-5.258S11.758 3.6 11.758 6.5 9.4 11.758 6.5 11.758 1.242 9.4 1.242 6.5z"
  }));
};

export default IconExchange;